import { render, staticRenderFns } from "./NewsListRisk.vue?vue&type=template&id=fc70d974&scoped=true"
import script from "./NewsListRisk.vue?vue&type=script&lang=js"
export * from "./NewsListRisk.vue?vue&type=script&lang=js"
import style0 from "./NewsListRisk.vue?vue&type=style&index=0&id=fc70d974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc70d974",
  null
  
)

export default component.exports